import React, { useState } from "react";
import axios from "axios";
import { BASE_API_URL, DEFAULT_AXIOS_OPTIONS } from "../../../AppConstants";

export const AddRole = ({ setLastChangeOccured }) => {
  const [name, setName] = useState("");
  const [responseMessage, setResponseMessage] = useState(null);

  const onCreateClick = () => {
    if (window.confirm(`Are you sure that you want to create?`)) {
      setResponseMessage("...Processing");

      axios
        .post(
          `${BASE_API_URL}/role`,
          {
            name,
          },
          DEFAULT_AXIOS_OPTIONS
        )
        .then(() => {
          setResponseMessage("Success");
          setLastChangeOccured(new Date());
          setName("");
        })
        .catch((error) => {
          setResponseMessage("Error");
          console.error("error", error);
        });
    }
  };

  return (
    <>
      <h3 className="has-text-left is-size-4">Add Role</h3>
      <div className="column is-two-thirds">
        <input
          className="input"
          type="text"
          placeholder="Role"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </div>
      <div className="column">
        <button
          className="btn btn-danger"
          disabled={name === ""}
          onClick={onCreateClick}
        >
          Create
        </button>
      </div>
      <p>{responseMessage ?? ""}</p>
    </>
  );
};
